import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AcademicYear } from 'src/shared/models/academic-year.model';
import { AcademicCalendarService } from 'src/shared/services/academic-calendar.service';
import { AuthService } from 'src/shared/services/auth.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { RulesService } from 'src/shared/services/rules.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-global-rules',
  templateUrl: './global-rules.component.html',
  styleUrl: './global-rules.component.scss'
})
export class GlobalRulesComponent implements OnInit {

  paramForm: FormGroup;
  editRuleForm: FormGroup;
  addRuleForm: FormGroup;
  addRuleFormForAll: FormGroup;
  columnsToDisplay = ['school_short_address', 'minimum_selection', 'maximum_selection', 'valid_from', 'action'];
  dataSchool: any[] = [];
  dataGlobalRules: any[] = [];
  apiSubscription: Subscription;
  loading = true;
  currentAcademic: any;
  showDetail = false;
  showData = false;
  invalidMinMaxAdd = false;
  invalidMinMaxAddForAll = false;
  invalidMinMaxEdit = false;
  @ViewChild('editRule', {static: true}) public modalEditRule: NgbModalRef;
  @ViewChild('addRule', {static: true}) public modalAddRule: NgbModalRef;
  @ViewChild('inputAll', {static: true}) public modalInputAll: NgbModalRef;

  constructor(
    private translate: TranslateService,
    private rpSer: ResponseService,
    public auth: AuthService,
    private ruleService: RulesService,
    private academicService: AcademicCalendarService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    this.translate.load('extracurricular');
    this.initParamForm();
    this.getCurrentAcademicYear();
    this.trackFormChanges();
  }

  viewRules() {
    this.router.navigate(['rules'], { relativeTo: this.route });
  }

  openModalInputAll() {
    this.modalService.open(this.modalInputAll, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {
    }, (reason: any) => {
    });
  }
  
  initParamForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
    });

    this.editRuleForm = new FormGroup({
      'global_rule_id': new FormControl(null),
      'maximum_selection': new FormControl(null),
      'minimum_selection': new FormControl(null),
      'valid_from': new FormControl(null),
    });

    this.addRuleForm = new FormGroup({
      'school_location_id': new FormControl(null),
      'maximum_selection': new FormControl(null),
      'minimum_selection': new FormControl(null),
      'valid_from': new FormControl(null),
    });

    this.addRuleFormForAll = new FormGroup({
      'maximum_selection': new FormControl(null),
      'minimum_selection': new FormControl(null),
      'valid_from': new FormControl(null),
    });
  }

  trackFormChanges() {
    this.addRuleForm.valueChanges.subscribe(() => {
      this.invalidMinMaxAdd = this.addRuleForm.value.minimum_selection > this.addRuleForm.value.maximum_selection;
    });

    this.editRuleForm.valueChanges.subscribe(() => {
      this.invalidMinMaxEdit = this.editRuleForm.value.minimum_selection > this.editRuleForm.value.maximum_selection;
    });

    this.addRuleFormForAll.valueChanges.subscribe(() => {
      this.invalidMinMaxAddForAll = this.addRuleFormForAll.value.minimum_selection > this.addRuleFormForAll.value.maximum_selection;
    });
  }

  onChangeAcademicYear(item: any) {
    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);
  }

  // onChangeSchoolLevel(item: any) {
  //   this.paramForm.controls['school_location_id'].markAsTouched();
  //   this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

  //   this.paramForm.controls['school_level_id'].markAsTouched();
  //   this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);
  // }

  getCurrentAcademicYear() {
      this.academicService.getAcademicYearsOnlyCurrent()
          .subscribe((response: AcademicYear) => {
            // @ts-ignore
            if (response['error'] === 0) {
              // @ts-ignore
              this.currentAcademic = new AcademicYear().deserialize(response['result']['data']);
            } else {
              // @ts-ignore
            }
          }, (error: any) => {
          });
    }

  getGlobalRules() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
      this.loading = false;
    }
    this.loading = true;
    const schoolLocationIds = this.dataSchool.map(item => +item.school_location_id);
    this.apiSubscription = this.ruleService.getGlobalRules(
      {
        school_location_ids: schoolLocationIds
      }
    ).subscribe(
      (response: any) => {
        if (response.status) {
          this.dataGlobalRules = response.data;
          this.showData = true;
        } else {
          this.rpSer.showAddError(response.message);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.rpSer.showAddError();
      }
    );
  }

  onGetEventSchoolLocation(data: any) {
    this.loading = true;
    this.dataSchool = data;
    this.getGlobalRules();
  }

  onEditGlobalRules(id: number) {
    this.showDetail = false;
    this.ruleService.getGlobalRulesDetail(id).subscribe(
      (response: any) => {
        if (response.status) {
          this.editRuleForm.reset();
          this.editRuleForm.controls['valid_from'].disable();
          this.editRuleForm.patchValue({
            global_rule_id: response.data.global_rule_id,
            maximum_selection: response.data.maximum_selection,
            minimum_selection: response.data.minimum_selection,
            valid_from: new Date(response.data.valid_from).toLocaleDateString('en-CA'),
          });
          this.showDetail = true;
          this.onOpenEditModal();
        } else {
          this.rpSer.showAddError(response.message);
        }
      },
      (error) => {
        this.rpSer.showAddError();
      }
    );
  }

  onOpenEditModal() {
    this.modalService.open(this.modalEditRule, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {
    }, (reason: any) => {
    });
  }

  onOpenAddModal(locId: number) {
    this.addRuleForm.reset();
    this.addRuleForm.patchValue({
      school_location_id: locId,
    });
    this.modalService.open(this.modalAddRule, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {
    }, (reason: any) => {
    });
  }

  onSaveGlobalRules() {
    if (this.editRuleForm.valid) {
      this.ruleService.updateGlobalRules(this.editRuleForm.value).subscribe(
        (response: any) => {
          if (response.status) {
            this.rpSer.showEditSuccess(response.message);
            this.getGlobalRules();
            this.modalService.dismissAll();
          } else {
            this.rpSer.showAddError(response.message);
          }
        },
        (error) => {
          this.rpSer.showAddError();
        }
      );
    }
  }

  onAddGlobalRules() {
    if (this.addRuleForm.valid) {
      this.ruleService.addGlobalRules(this.addRuleForm.value).subscribe(
        (response: any) => {
          if (response.status) {
            this.rpSer.showAddSuccess(response.message);
            this.getGlobalRules();
            this.modalService.dismissAll();
          } else {
            this.rpSer.showAddError(response.message);
          }
        },
        (error) => {
          this.rpSer.showAddError();
        }
      );
    }
  }

  onAddGlobalRulesForAll() {
    const schoolLocationIds = this.dataSchool.map(item => +item.school_location_id);
    if (this.addRuleFormForAll.valid) {
      this.ruleService.addGlobalRulesForAll({global_rules: this.addRuleFormForAll.value, school_location: schoolLocationIds}).subscribe(
        (response: any) => {
          if (response.status) {
            this.rpSer.showAddSuccess(response.message);
            this.getGlobalRules();
            this.modalService.dismissAll();
          } else {
            this.rpSer.showAddError(response.message);
          }
        },
        (error) => {
          this.rpSer.showAddError();
        }
      );
    }
  }

  onDeleteGlobalRules(id: number) {
    Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to delete this rule?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        this.ruleService.deleteGlobalRules(id).subscribe(
          (response: any) => {
            if (response.status) {
              this.rpSer.showDeleteSuccess(response.message);
              this.getGlobalRules();
            } else {
              this.rpSer.showAddError(response.message);
            }
          },
          (error) => {
            this.rpSer.showAddError();
          }
        );
      }
    });
  }
}
